<template>
  <v-container flex grid-list-md>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout column v-else>
      <v-flex>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Formas de pagameto extra</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialogNovoPagamento"
            :fullscreen="$vuetify.breakpoint.xs"
            lazy
            hide-overlay
            transition="dialog-bottom-transition"
            width="500"
          >
            <v-btn icon color="info" slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cad-pagamento
              @fechar="dialogNovoPagamento = false"
              @success="showInfo"
              @erro="showError"
            ></cad-pagamento>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex class="text-xs-center">
        <v-progress-circular v-if="loading" indeterminate size="150" class="ma-5" color="primary"></v-progress-circular>
        <v-list v-else>
          <v-subheader
            class="title font-weight-regular primary--text"
          >Formas de pagamento cadastradas</v-subheader>
          <template v-for="pagamento in pagamentosExtra">
            <v-list-tile :key="pagamento.id" avatar>
              <v-list-tile-avatar>
                <v-avatar>
                  <v-icon color="green">credit_card</v-icon>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="pagamento.descricao"></v-list-tile-title>
                <v-list-tile-sub-title v-text="`Pagamento n° ${pagamento.id}`"></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title class="body-2 font-weight-regular grey--text text--darken-2">
                  Pagamento
                  <span v-if="pagamento.pagamento_secundario">Secundário</span>
                  <span v-else>Primário</span>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title class="body-2 font-weight-regular grey--text text--darken-2">
                  <v-icon
                    :color="pagamento.aceita_credito ? 'green' : 'grey lighten-1'"
                  >check_circle</v-icon>Aceita Crédito
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title class="body-2 font-weight-regular grey--text text--darken-2">
                  <v-icon :color="pagamento.aceita_debito ? 'green' : 'grey lighten-1'">check_circle</v-icon>Aceita Débito
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-list-tile-action-text
                  v-text="pagamento.url"
                  class="grey--text text--darken-3 body-1"
                ></v-list-tile-action-text>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-btn icon @click="selecionarPagamento(pagamento)">
                  <v-icon color="error">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
          <v-list-tile v-if="!pagamentosExtra.length" class="pa-3">
            <v-list-tile-content>
              <v-list-tile-title
                class="text-xs-center title font-weight-light"
              >Sem formas de pagamentos extra cadastradas</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="4000"
      :vertical="true"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
    <v-dialog lazy width="300" v-model="dialogCancelamento">
      <v-card>
        <v-card-text
          v-text="`Tem certeza que deseja apagar a forma de pagamento n° ${pagamento_selected ? pagamento_selected.id: 0}?`"
          class="headline primary--text text-xs-center"
        ></v-card-text>
        <v-card-actions>
          <v-btn flat block color="green" @click="dialogCancelamento = false">CANCELAR</v-btn>
          <v-btn flat block color="error" @click="apagarPagamento()">CONFIRMAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
const CadPagamento = () => import('../../components/cadastros/CadPagExtra.vue')

export default {
  components: {
    CadPagamento,
    SmartLockMessage
  },
  data () {
    return {
      pagamento_selected: null,
      dialogNovoPagamento: false,
      snackbar: {
        active: false,
        color: 'info',
        text: ''
      },
      dialogCancelamento: false
    }
  },
  computed: {
    pagamentosExtra () {
      return this.$store.getters.pagamentosExtra
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  watch: {
    headers (val) {
      if (val) {
        this.$store.dispatch('listPagamentosExtra')
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.$store.dispatch('listPagamentosExtra')
    }
  },
  methods: {
    selecionarPagamento (pagamento) {
      this.pagamento_selected = pagamento
      this.dialogCancelamento = true
    },
    apagarPagamento () {
      this.$store
        .dispatch('apagarPagamentoExtra', this.pagamento_selected.id)
        .then(info => {
          this.$store.dispatch('listPagamentosExtra')
          this.dialogCancelamento = false
          this.showInfo(info)
        })
        .catch(error => {
          this.dialogCancelamento = false
          this.showError(error)
        })
    },
    showInfo (info) {
      this.snackbar.text = info
      this.snackbar.color = 'info'
      this.snackbar.active = true
      this.dialogNovoPagamento = false
    },
    showError (error) {
      this.snackbar.text = error
      this.snackbar.color = 'error'
      this.snackbar.active = true
      this.dialogNovoPagamento = false
    }
  }
}
</script>
